import {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import ModalNuevaPass from '../../components/Modals/ModalNuevaPass/ModalNuevaPass'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import InputIcon from '../../components/Inputs/InputIcon'
import DarkPass from '../../media/felsv/dark_lock-key-alt_icon.svg'
import SecondaryPass from '../../media/felsv/secondary_lock-key-alt_icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionsOlvidoPass, actionsValidacionesOlvidoPass} from '../../actions/action-creators'
import {olvidoPassClear} from '../../actions/OlvidoPass/olvidoPass.actions'
import {REGEX_PASSWORD} from '../../constants/Regex'
import {KEYS} from '../../constants/keysStorage'
import {DICCIONARIO} from '../../constants/Diccionario'

export const RestorePasswordUser = (props: any) => {
  const history = useHistory()
  const [disabled, setDisabled] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const {formPassword, errorFormPassword} = useSelector((state: State) => state.olvidoPass)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsOlvidoPass, dispatch)
  const validaciones = bindActionCreators(actionsValidacionesOlvidoPass, dispatch)

  useEffect(() => {
    dispatch(olvidoPassClear())
    const username = localStorage.getItem(KEYS?.USERNAME_CLIENTE_RESTORE)
    const token = localStorage.getItem(KEYS?.TOKEN)
    if (!username && !token) return history.push('/')
    return () => {
      localStorage.removeItem(KEYS.USERNAME_CLIENTE)
      dispatch(olvidoPassClear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      formPassword.passwd &&
      formPassword.passwd2 &&
      !errorFormPassword.passwd &&
      !errorFormPassword.passwd2
    )
      setDisabled(false)
    else setDisabled(true)
  }, [formPassword, errorFormPassword])

  const send = async (e: any) => {
    e.preventDefault()
    if (await validaciones.opValidacionesFormPasswordEnviar()) return
    if (await actions.restablecerPasswordTemporal()) {
      setOpenModal(true)
      dispatch(olvidoPassClear())
    }
  }

  const onClose = () => {
    localStorage.removeItem(KEYS.TOKEN)
    localStorage.removeItem(KEYS.USERNAME_CLIENTE_RESTORE)
    setOpenModal(false)
    history.push('/')
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    actions.olvidoPassFormNewPassHanldeCHangeInput(e)
    validaciones.opValidacionesFormPasswordOnBlur(e)
  }

  return (
    <DesignExterno
      title={
        <span>
          Bienvenido a <span style={{color: '#019FC5'}}>FELes APP</span>
        </span>
      }
    >
    {openModal && <ModalNuevaPass onClose={onClose} />}
      <section className='wf-section centrar-horizontal'>
        <div className='w-form'>
          <form
            className='form-content'
            data-wf-page-id='64af1641b0eebbdb1aafe5e8'
            data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
            onSubmit={send}
          >
            <div>
              <h2 className='h2-titles'>Nueva contraseña</h2>
              <div>Escribe tu nueva contraseña</div>
            </div>
            <div className='form-separator'></div>
            <div>
              <label htmlFor='passwd' className='field-label m'>
                {DICCIONARIO.PASSWORD}
              </label>
            {(!REGEX_PASSWORD.test(formPassword.passwd) ||
              !REGEX_PASSWORD.test(formPassword.passwd2)) && (
              <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
                La contraseña debe tener mínimo 5 caracteres, al menos un dígito, una minúscula, una
                mayúscula y un carácter no alfanumérico.
              </div>
            )}
              <InputIcon
                secondaryIcon={SecondaryPass}
                darkIcon={DarkPass}
                type='password'
                className='m text-field-icon pass w-input'
                maxLength={50}
                name='passwd'
                data-name='passwd'
                placeholder={DICCIONARIO.PASSWORD}
                id='passwd'
                value={formPassword.passwd}
                onChange={handleChange}
                onBlur={validaciones.opValidacionesFormPasswordOnBlur}
              />
              {errorFormPassword.passwd && <p className='alert s'>{errorFormPassword.passwd}</p>}
            </div>
            <div>
              <label htmlFor='passwd2' className='field-label m'>
                {DICCIONARIO.CONFIRM_PASSWORD}
              </label>
              <InputIcon
                secondaryIcon={SecondaryPass}
                darkIcon={DarkPass}
                type='password'
                className='m text-field-icon pass w-input'
                maxLength={50}
                name='passwd2'
                data-name='passwd2'
                placeholder={DICCIONARIO.CONFIRM_PASSWORD}
                id='passwd2'
                value={formPassword.passwd2}
                onChange={handleChange}
                onBlur={validaciones.opValidacionesFormPasswordOnBlur}
              />
              {errorFormPassword.passwd2 && <p className='alert s'>{errorFormPassword.passwd2}</p>}
            </div>
            {!errorFormPassword.passwd2 &&
              !errorFormPassword.passwd &&
              formPassword.passwd2 &&
              formPassword.passwd !== formPassword.passwd2 && (
                <p className='alert s'>Las contraseñas no coinciden</p>
              )}
            <div className='m buttons-div' style={{marginBottom: '5%'}}>
              <button
                type='submit'
                className='m button w-inline-block'
                disabled={disabled || formPassword.passwd !== formPassword.passwd2}
              >
                Continuar
              </button>
            </div>
          </form>
        </div>
      </section>
    </DesignExterno>
  )
}
